module.exports = function (Konva) {
    'use strict';
    function createSegmentMarker(options) {
        var handleHeight = 20;
        var handleWidth = handleHeight / 2;
        var handleY = options.height / 2 - 10.5;
        var handleX = -(handleWidth / 2) + 0.5;
        var group = new Konva.Group({
            draggable: options.draggable,
            dragBoundFunc: function (pos) {
                var limit;
                if (options.inMarker) {
                    limit = options.segmentGroup.outMarker.getX() - options.segmentGroup.outMarker.getWidth();
                    if (pos.x > limit) {
                        pos.x = limit;
                    }
                } else {
                    limit = options.segmentGroup.inMarker.getX() + options.segmentGroup.inMarker.getWidth();
                    if (pos.x < limit) {
                        pos.x = limit;
                    }
                }
                return {
                    x: pos.x,
                    y: this.getAbsolutePosition().y
                };
            }
        });
        if (options.draggable && options.onDrag) {
            group.on('dragmove', function (event) {
                options.onDrag(options.segmentGroup, options.segment);
            });
        }
        var xPosition = options.inMarker ? -24 : 24;
        var text = new Konva.Text({
            x: xPosition,
            y: options.height / 2 - 5,
            text: '',
            fontSize: 10,
            fontFamily: 'sans-serif',
            fill: '#000',
            textAlign: 'center'
        });
        text.hide();
        group.label = text;
        var handle = new Konva.Rect({
            x: handleX,
            y: handleY,
            width: handleWidth,
            height: handleHeight,
            fill: options.color,
            stroke: options.color,
            strokeWidth: 1
        });
        var line = new Konva.Line({
            x: 0,
            y: 0,
            points: [
                0.5,
                0,
                0.5,
                options.height
            ],
            stroke: options.color,
            strokeWidth: 1
        });
        handle.on('mouseover', function (event) {
            if (options.inMarker) {
                text.setX(xPosition - text.getWidth());
            }
            text.show();
            options.layer.draw();
        });
        handle.on('mouseout', function (event) {
            text.hide();
            options.layer.draw();
        });
        group.add(text);
        group.add(line);
        group.add(handle);
        return group;
    }
    function createSegmentLabel(segmentGroup, segment) {
        return new Konva.Text({
            x: 12,
            y: 12,
            text: segment.labelText,
            textAlign: 'center',
            fontSize: 12,
            fontFamily: 'Arial, sans-serif',
            fill: '#000'
        });
    }
    function createPointMarker(options) {
        var handleTop = options.height / 2 - 10.5;
        var handleWidth = 10;
        var handleHeight = 20;
        var handleX = -(handleWidth / 2) + 0.5;
        var group = new Konva.Group({
            draggable: options.draggable,
            dragBoundFunc: function (pos) {
                return {
                    x: pos.x,
                    y: this.getAbsolutePosition().y
                };
            }
        });
        if (options.draggable && options.onDrag) {
            group.on('dragmove', function (event) {
                options.onDrag(options.pointGroup, options.point);
            });
        }
        if (options.onDblClick) {
            group.on('dblclick', function (event) {
                options.onDblClick(options.point);
            });
        }
        if (options.draggable && options.onDragEnd) {
            group.on('dragend', function (event) {
                options.onDragEnd(options.point);
            });
        }
        if (options.onMouseEnter) {
            group.on('mouseenter', function (event) {
                options.onMouseEnter(options.point);
            });
        }
        if (options.onMouseLeave) {
            group.on('mouseleave', function (event) {
                options.onMouseLeave(options.point);
            });
        }
        var text = null;
        if (options.showLabel) {
            text = new Konva.Text({
                x: 2,
                y: 12,
                text: options.point.labelText,
                textAlign: 'left',
                fontSize: 10,
                fontFamily: 'sans-serif',
                fill: '#000'
            });
            group.label = text;
        }
        var handle = null;
        if (options.draggable) {
            handle = new Konva.Rect({
                x: handleX,
                y: handleTop,
                width: handleWidth,
                height: handleHeight,
                fill: options.handleColor
            });
        }
        var line = new Konva.Line({
            x: 0,
            y: 0,
            points: [
                0,
                0,
                0,
                options.height
            ],
            stroke: options.handleColor,
            strokeWidth: 1
        });
        var time = null;
        if (handle) {
            time = new Konva.Text({
                x: -24,
                y: options.height / 2 - 5,
                text: '',
                fontSize: 10,
                fontFamily: 'sans-serif',
                fill: '#000',
                textAlign: 'center'
            });
            time.hide();
            group.time = time;
            handle.on('mouseover', function (event) {
                time.setX(-24 - time.getWidth());
                time.show();
                options.layer.draw();
            });
            handle.on('mouseout', function (event) {
                time.hide();
                options.layer.draw();
            });
        }
        if (handle) {
            group.add(handle);
        }
        group.add(line);
        if (text) {
            group.add(text);
        }
        if (time) {
            group.add(time);
        }
        return group;
    }
    function scaleY(amplitude, height) {
        var range = 256;
        var offset = 128;
        return height - (amplitude + offset) * height / range;
    }
    function drawWaveform(context, waveformData, frameOffset, startPixels, endPixels, width, height) {
        if (startPixels < frameOffset) {
            startPixels = frameOffset;
        }
        var limit = frameOffset + width;
        if (endPixels > limit) {
            endPixels = limit;
        }
        var adapter = waveformData.adapter;
        var x, val;
        context.beginPath();
        for (x = startPixels; x < endPixels; x++) {
            val = adapter.at(2 * x);
            context.lineTo(x - frameOffset + 0.5, scaleY(val, height) + 0.5);
        }
        for (x = endPixels - 1; x >= startPixels; x--) {
            val = adapter.at(2 * x + 1);
            context.lineTo(x - frameOffset + 0.5, scaleY(val, height) + 0.5);
        }
        context.closePath();
    }
    return {
        drawWaveform: drawWaveform,
        createSegmentMarker: createSegmentMarker,
        createPointMarker: createPointMarker,
        createSegmentLabel: createSegmentLabel
    };
}(require('konva'));